var _effectorFileName = "/builds/gmini/front-ui-kit/src/ResizableColumns/utils/persistent.ts";
import { convertPxToPc } from './convert';
import { correctWidths } from './correct-widths';
export function saveToStorage({
  widthsPc,
  foldedWidthPx,
  containerW,
  storage,
  storageKey
}) {
  const foldedWidthPc = convertPxToPc(foldedWidthPx, containerW);
  const items = correctWidths({
    containerW,
    foldedWidthPx,
    widthsPc
  }).map(w => ({
    widthPc: w,
    expanded: foldedWidthPc < w
  }));
  storage.setItem(storageKey, JSON.stringify(items));
}
export function getFromStorage({
  containerW,
  foldedWidthPx,
  widthsPc,
  storage,
  storageKey
}) {
  const stateItems = parseJsonPanelItems(storage.getItem(storageKey) || ''); // validate items length

  if (widthsPc.length !== stateItems.length) {
    return widthsPc;
  } // set corrected width for folded items (calculated by container width)


  const foldedWidthPc = convertPxToPc(foldedWidthPx, containerW);
  const correctedWidthsPc = correctWidths({
    widthsPc: stateItems.map(({
      expanded,
      widthPc
    }) => expanded ? widthPc : foldedWidthPc),
    containerW,
    foldedWidthPx
  });
  return correctedWidthsPc;
}

function parseJsonPanelItems(json) {
  try {
    const items = JSON.parse(json);

    if (!Array.isArray(items)) {
      return [];
    }

    const itemsIsValid = items.every(item => typeof item === 'object' && typeof item.widthPc === 'number' && !isNaN(item.widthPc) && typeof item.expanded === 'boolean');
    return itemsIsValid ? items : [];
  } catch (error) {
    return [];
  }
}